import { render, staticRenderFns } from "./showImage.vue?vue&type=template&id=8af3461e&scoped=true"
import script from "./showImage.vue?vue&type=script&lang=js"
export * from "./showImage.vue?vue&type=script&lang=js"
import style0 from "./showImage.vue?vue&type=style&index=0&id=8af3461e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af3461e",
  null
  
)

export default component.exports